<template>
  <div v-if="item && schema" class="row pl-3 pb-3 pr-3 pt-1">
    <template v-for="(value, key) in item">
      <div
        v-if="isVisible(key) && key !== 'comment'"
        :key="key"
        :class="cols"
        class="pt-3"
      >
        <div class="regular text-gray" v-text="schema[key].label" />
        <div class="regular" v-text="getDisplayProperty(value, key)" />
      </div>
    </template>
    <!-- Mostrar comentario con formato especial -->
    <slot name="actions" />
    <div v-if="hasComment" class="col-12 pt-3">
      <div class="row">
        <div class="col-12">
          <div class="regular text-gray">Comentario</div>
          <hr style="border: 1px solid #e7e7e7;" />
        </div>
        <div class="col-12 col-md pt-2">
          <div class="regular text-gray">Fecha:</div>
          <div class="regular bold">{{ commentDate }}</div>
          <div class="regular">{{ commentTime }}</div>
        </div>
        <div class="col-12 col-md pt-2">
          <div class="regular text-gray">Usuario:</div>
          <div class="regular">{{ item.commentedByUsername || '-' }}</div>
        </div>
        <div class="col-12 col-md pt-2">
          <div class="regular text-gray">Rol:</div>
          <div class="regular">{{ item.commentedByRoleName || '-' }}</div>
        </div>
        <div class="col-12 col-md pt-2">
          <div class="regular text-gray">Nombre completo:</div>
          <div class="regular">{{ item.commentCreatedBy || '-' }}</div>
        </div>
        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">Comentario:</div>
          <div class="regular">{{ item.comment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceItem',
  props: {
    schema: { type: Object, required: true, default: null },
    item: { type: Object, required: true, default: null },
    cols: { type: String, required: true, default: '' },
    placeholder: { type: String, default: '-' },
  },
  computed: {
    hasComment() {
      return (
        this.item &&
        this.item.comment &&
        typeof this.item.comment === 'string' &&
        this.item.comment.trim() !== ''
      );
    },
    commentDate() {
      return this.item.commentDate ? this.item.commentDate.split(' ')[0] : '-';
    },
    commentTime() {
      return this.item?.commentDate?.replace(this.commentDate, '') || '-';
    },
  },
  methods: {
    isVisible(key) {
      if (!this.schema[key] || this.schema[key].hideInDetail) {
        return false;
      }

      const visibleIf = this.schema[key]?.visibleIf;
      if (!visibleIf) {
        return true;
      }

      const valueToCompare = visibleIf.valueKey
        ? this.item[visibleIf.property]?.[visibleIf.valueKey]
        : this.item[visibleIf.property];
      if (valueToCompare) {
        return [...visibleIf.includes].includes(valueToCompare);
      }

      return false;
    },
    getDisplayProperty(value, key) {
      const schema = this.schema[key];

      let _value = value;

      if (schema.replaceIf) {
        const { name, equals } = schema.replaceIf.ownProperty;
        if (equals === value[name]) {
          _value = this.item[schema.replaceIf.property] || this.placeholder;
          if (schema.replaceIf.prependText) {
            _value = `${schema.replaceIf.prependText}${_value}`;
          }
          return _value;
        }
      }
      if (schema.displayKey) {
        _value = value[schema.displayKey] || this.placeholder;
      }
      if (schema.prependText) {
        _value = `${schema.prependText}${_value}`;
      }

      return _value;
    },
  },
};
</script>
